import { render, staticRenderFns } from "./activityRecommend.vue?vue&type=template&id=68a35db0&scoped=true"
import script from "./activityRecommend.vue?vue&type=script&lang=js"
export * from "./activityRecommend.vue?vue&type=script&lang=js"
import style0 from "./activityRecommend.vue?vue&type=style&index=0&id=68a35db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a35db0",
  null
  
)

export default component.exports